import React, { FunctionComponent, PropsWithChildren } from "react";
import { RoundHistory, RoundType } from "../type";
import Utils from "../utils";
import { useTranslator } from "../context/TranslationContext";

type Props = {
  roundHistory: RoundHistory;
  gameCode: string;
};
const { REACT_APP_SHOW_END_CREDIT } = process.env;

export const BuyFreeSpinRoundHistoryView: FunctionComponent<
  PropsWithChildren<Props>
> = ({ roundHistory, children, gameCode }) => {
  let endDateText = <></>;
  const translator = useTranslator();
  switch (roundHistory.state) {
    case "Leave":
      endDateText = (
        <>
          {Utils.changeTimezoneAndFormat(roundHistory.endedDate)}
          <span className="text-danger fw-bolder">
            {roundHistory.state === "Leave" ? "  (Overtime)" : ""}
          </span>
        </>
      );
      break;
    case "Start":
      endDateText = <>{translator.get("on_going")}</>;

      break;
    case "Closed":
      endDateText = (
        <>{Utils.changeTimezoneAndFormat(roundHistory.endedDate)}</>
      );
      break;
  }

  return (
    <>
      <div className="px-3">
        <h1>{roundHistory.roundReferenceNumber}</h1>
        <hr />
        <div className="card mb-3">
          <div className="card-body">
            <h4 className="card-title pb-2">
              {translator.get("details_header")}
            </h4>
            <hr />
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <td>{translator.get("game_name")}</td>
                  <td>{translator.getGameName(gameCode)}</td>
                </tr>
                <tr>
                  <td>{translator.get("bet")}</td>
                  <td>
                    {roundHistory.roundType === RoundType.FreePlay
                      ? Utils.asCurrency(0) +
                        " (" +
                        translator.get("free_play") +
                        ")"
                      : Utils.asCurrency(
                          roundHistory.buyFreeSpin
                            ? roundHistory.betAmount /
                                roundHistory.buyFreeSpinRate
                            : roundHistory.betAmount
                        )}
                  </td>
                </tr>
                <tr>
                  <td>{translator.get("buy_free_spin_amount")}</td>
                  <td>
                    {Utils.asCurrency(
                      roundHistory.buyFreeSpin ? roundHistory.betAmount : 0
                    )}
                  </td>
                </tr>
                <tr>
                  <td>{translator.get("win")}</td>
                  <td>{Utils.asCurrency(roundHistory.winAmount)}</td>
                </tr>
                <tr>
                  <td>{translator.get("roundReferenceNumber")}</td>
                  <td>{roundHistory.roundReferenceNumber}</td>
                </tr>
                <tr>
                  <td>{translator.get("start_date")}(DD/MM/YYYY)</td>
                  <td>
                    {Utils.changeTimezoneAndFormat(roundHistory.startedDate)}
                  </td>
                </tr>
                <tr>
                  <td>{translator.get("end_date")}(DD/MM/YYYY)</td>
                  <td>{endDateText}</td>
                </tr>
                {REACT_APP_SHOW_END_CREDIT === "show" &&
                  roundHistory.endBalance && (
                    <tr>
                      <td>{translator.get("details_credit")}</td>
                      <td>{Utils.asCurrency(roundHistory.endBalance, 2)}</td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </div>
        {children}
      </div>
    </>
  );
};
